import {
  Card,
  CardContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useLiteRaveCreateContext } from "../LiteRaveCreateContext";
import { CodeSection } from "./CodeSection";
import { RecipientSection } from "./RecipientSection";
import { Actions } from "./Actions";

export const Form = () => {
  const {
    handleSubmit,
    title,
    setTitle,
    loading,
    selectedProgramId,
    setSelectedProgramId,
    programs,
  } = useLiteRaveCreateContext();

  return (
    <Card>
      <CardContent sx={{ p: 4 }}>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Recognition Message"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            multiline
            rows={4}
            sx={{ mb: 3 }}
            disabled={loading}
            required
            placeholder="e.g., Great job on the presentation!"
            helperText="Enter a short message to recognize your team member"
          />

          <FormControl fullWidth sx={{ mb: 3 }} required>
            <InputLabel>Program</InputLabel>
            <Select
              value={selectedProgramId}
              label="Program"
              onChange={(e) => {
                setSelectedProgramId(e.target.value);
              }}
              disabled={loading}
            >
              {programs.map((prog) => (
                <MenuItem key={prog.id} value={prog.id}>
                  {prog.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <CodeSection />
          <RecipientSection />
          <Actions />
        </form>
      </CardContent>
    </Card>
  );
};
